// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"yE-z","smallCardRow":"zE-z","largeCardRow":"AE-z","productSearchRow":"BE-z","curatedRow":"CE-z"};